import { QueryFunctionContext } from '@tanstack/react-query'
import { ProductCatalogPricingService } from 'shared/services/ProductCatalogPricingService'
import type { PCT } from 'shared/types/vp/pct'

export const queryBatchEstimatedPricing = async (
  context: QueryFunctionContext<PCT.Queries.ProductCatalogPricingService.QuantitiesPriceQueryKey>,
): Promise<PCT.Models.ProductCatalogPricingService.QuantitiesPricingResult | null> => {
  const { queryKey } = context
  const [_, { market, productKey, quantities, productVersion, pricingContext, selections }] = queryKey

  const prices = await ProductCatalogPricingService.getQuantityPrices(market, productKey, quantities, productVersion, pricingContext, selections)

  if (!prices || !prices.estimatedPrices) {
    return null
  }

  return prices
}
